'use client';

import { useCallback, useState } from 'react';
import { DropCountdown } from '@/components/teaser/drop-countdown';

/**
 * Client wrapper for the drop countdown inside the CMS hero banner: owns the
 * live state so the server-rendered hero can embed it, and swaps to the
 * "It's live." badge when the countdown hits zero.
 */
export function HeroDropCountdown({
	targetMs,
	alignment = 'center',
}: {
	targetMs?: number;
	alignment?: string;
}) {
	const [live, setLive] = useState(false);
	const handleLive = useCallback(() => setLive(true), []);

	const alignmentClasses: Record<string, string> = {
		left: 'justify-start',
		center: 'justify-center',
		right: 'justify-end',
	};

	return (
		<div className={`flex ${alignmentClasses[alignment] || alignmentClasses.center}`}>
			{live ? (
				<div className="mt-7 inline-flex items-center rounded bg-[#B01E24] px-6 py-3.5 font-black text-[clamp(26px,6vw,36px)] text-white uppercase leading-none tracking-[-.02em]">
					It&rsquo;s live.
				</div>
			) : (
				<DropCountdown onLive={handleLive} targetMs={targetMs} />
			)}
		</div>
	);
}
